

export default class CourseDTO {

  public id?: number;
  public type?: string;
  public name?: string;
  public courseDate?: string;
  public course_date?: string;


  public created_by?: string;
  public first_created?: string;
  public status?: number;



  // constructor(type: EventTypeDTO, date: string, stage: string, timezone: string, link: string, description: string, eventLanguage: string, id?: number) {
  //   this.type = type;
  //   this.date = date;
  //   this.stage = stage;
  //   this.timezone = timezone;
  //   this.link = link;
  //   this.description = description;
  //   this.eventLanguage = eventLanguage;
  // }

}
